import React, {FunctionComponent} from 'react';
import cn from 'classnames';

import {StageState} from 'enums';
import './StageStateColor.scss';

interface IStageStateColorProps {
    className?: string
    state: StageState,
}

const stateClasses = {
    [StageState.Scheduled]: 'scheduled',
    [StageState.Running]: 'running',
    [StageState.Canceled]: 'canceled',
    [StageState.Error]: 'error',
    [StageState.Done]: 'done',
}

export const StageStateColor: FunctionComponent<IStageStateColorProps> = function StageStateColor(props) {
    const { children, className, state } = props;

    return (
        <span className={cn('stageStateColor', className, stateClasses[state])}>
            {children}
        </span>
    )
};